function applyAccessibilityFixes() {
  // Fix empty buttons
  document.querySelectorAll('button').forEach(function(btn) {
    if (!btn.getAttribute('aria-label') && !btn.textContent.trim()) {
      btn.setAttribute('aria-label', 'Toggle menu');
    }
  });

  // Fix empty links
  document.querySelectorAll('a').forEach(function(link) {
    if (!link.getAttribute('aria-label') && !link.textContent.trim() && !link.querySelector('img[alt]')) {
      link.setAttribute('aria-label', 'Link');
    }
  });

  // Fix inputs missing labels
  document.querySelectorAll('input').forEach(function(input) {
    var id = input.getAttribute('id');
    if (id && document.querySelector('label[for="' + id + '"]')) return;
    var placeholder = input.getAttribute('placeholder');
    if (placeholder) {
      input.setAttribute('aria-label', placeholder);
    }
  });
}

// Run on load
document.addEventListener('DOMContentLoaded', applyAccessibilityFixes);

// Watch for dynamic DOM changes
var observer = new MutationObserver(function() {
  applyAccessibilityFixes();
});

observer.observe(document.body, { childList: true, subtree: true });
